import { Fragment } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { uiActions } from "../../../store/Ui-slice";
const Backdrop = () => {
  const dispatch = useDispatch();
  const hidePaymentModalHandler = () => {
    dispatch(uiActions.paymentModalPopUpToggle(false));
  };
  return (
    <div
      className="fixed p-0 inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-30 "
      onClick={hidePaymentModalHandler}
    ></div>
  );
};
const ModalOverlay = (props: any) => {
  return (
    // <div className="fixed inset-1/3 p-0 m-0 z-30">
    <div className="absolute top-1/2 right-0 left-0 w-96 p-0 m-0  z-30 mx-auto">
      <div className="  top-24 p-0  ">{props.children}</div>
    </div>
  );
};
const portalElement: any = document.getElementById("paymentOverlay");
const PaymentModal = (props: any) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay>{props.children}</ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default PaymentModal;
